import React from 'react';
import { useState } from "react";
import CharacteristicModal from './../components/CharacteristicModal';
import FolderModal from './../components/FolderModal';
import DeleteModal from './../modal/delete/DeleteModal';
import ModalWrap from "./../modal/ModalWrap";
import Tree from './../components/Tree';

const GroupingCharacteristicsModule = ({ 
  handeleWrapClick,
  modalRef,
  modalRefHeader,
  items,
  catsItems,
  addCatItem,
  deleteCatItem,
  updateItemCatName
}) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const closeModal = () => setModalIsOpen(false);

    const [currentCharacteristic, setCurrentCharacteristic] = useState({ name: '', type: '' });
    const [characteristics, setCharacteristics] = useState([]);

    const [folderModalIsOpen, setFolderModalIsOpen] = useState(false);
    const closeFolderModal = () => setFolderModalIsOpen(false);

    const [folders, setFolders] = useState([]);
    const [folderModalHeader, setFolderModalHeader] = useState('');
    const [isCreateCat, setIsCreateCat] = useState(false);

    const [selectedId, setSelectedId] = useState(null);
    const [selectedParent, setSelectedParent] = useState(null);

    const [selectedParamId, setSelectedParamId] = useState(null);
    const [selectedCatId, setSelectedCatId] = useState(null);
    const [selectedCatOrderId, setSelectedCatOrderId] = useState(null);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isDeleteParamFromCatModalOpen, setIsDeleteParamFromCatModalOpen] = useState(false);

    const [previousCharacteristic, setPreviousCharacteristic] = useState({ name: '', type: '' });

    const [selectedItems, setSelectedItems] = useState(new Set());

    const [itemsTypes, setItemsTypes] = useState([]);
    const [itemsCatOrder, setItemsCatOrder] = useState([]);

    /*const openModal = (isAdd = false) => {
        //setCurrentCharacteristic(characteristic);
        if (isAdd) {
          setCurrentCharacteristic({ name: '', type: '' });
        }
        else {
          setCurrentCharacteristic({ name: previousCharacteristic.name, type: previousCharacteristic.type });
        }
        setModalIsOpen(true);
      };*/

    const handleCharacteristicSubmit = (characteristic) => {
        //setCharacteristics([...characteristics, characteristic]);
        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/insertParamInLibrary`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({name: characteristic.name, parent: selectedParent, paramtype: characteristic.type, isFolder: 0, reportName: characteristic.name, isshown: 1})
          })
        .then(response => {
          console.log("characteristic added");
        })
        .catch(error => {
                console.error('Ошибка добавления характеристики: ', error);
        });
      };

      const handleFolderSubmit = (folderName) => {
        console.log('Folder Name:', folderName);

        if (isCreateCat) {
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/insertToLibParamsCat`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({catname: folderName})
            })
          .then(response => {
            response.json().then(async response => {
              addCatItem(response.id, folderName, response.id)})
            })
          .catch(error => {
                  console.error('Ошибка создания категории: ', error);
          });
        }
        else {
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/updateLibParamCat`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({catname: folderName, id: selectedCatId})
            })
          .then(response => {
            console.log("category updated");
            updateItemCatName(selectedCatId, folderName);
          })
          .catch(error => {
                  console.error('Ошибка обновления категории: ', error);
          });
        }
      };

      const openFolderModal = (isCreate) => {
        setIsCreateCat(isCreate);
        if (isCreate) {
          setCurrentCharacteristic({ name: '', type: '' });
          setFolderModalHeader('Создать категорию');
        }
        else {
          setCurrentCharacteristic({ name: previousCharacteristic.name, type: previousCharacteristic.type });
          setFolderModalHeader('Редактировать категорию');
        }
         setFolderModalIsOpen(true);
      }

      const handleSelect = (item) => {

          setSelectedId(item.id);
          setSelectedParamId(null);
          setItemsCatOrder([]);
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/selectParamsFromLibraryByTypecode?typecode=${item.id}`)
          .then(response => response.json())
          .then(data => {
           // setInfo(response);
            setItemsTypes(data);

          })
          .catch(error => {
            console.error('Ошибка при загрузке данных:', error);
            //setLoading(false);
          });
          if (typeof selectedCatId === 'number' && !isNaN(selectedCatId)) {
            console.log("click = " + selectedCatId);
            selectCategory(item.id, selectedCatId);
          }
      };

      const getParamItemById = (id) => {
        return itemsTypes.find(item => item.id === id);
      };

      const getParamOrderByParamcode = (id) => {
        return itemsCatOrder.find(item => item.paramcode === id);
      };

      const getParamOrderById = (id) => {
        return itemsCatOrder.find(item => item.id === id);
      };

      const getPreviousParamOrder = (targetId) => {
        // Находим индекс целевого элемента
        const index = itemsCatOrder.findIndex(item => item.id === targetId);
      
        if (index === -1) return null; // Если элемент не найден, возвращаем null
      
        const previousItem = itemsCatOrder[index - 1] || null; // Предыдущий элемент, если он есть
      
        return previousItem;
      };

      const getNextParamOrder = (targetId) => {
        // Находим индекс целевого элемента
        const index = itemsCatOrder.findIndex(item => item.id === targetId);
      
        if (index === -1) return null; // Если элемент не найден, возвращаем null
      
        const nextItem = itemsCatOrder[index + 1] || null; // Предыдущий элемент, если он есть
      
        return nextItem;
      };

      /*const updateItemParamOrderByOrder = (paramorder, newParamOrder, id) => {
        setItemsCatOrder(itemsCatOrder.map(item =>
          item.paramorder === paramorder && item.id != id
            ? { ...item, paramorder: newParamOrder }
            : item
        ));
      };*/

      const updateParamOrderById = (id, newParamOrder) => {
        // Копируем массив, чтобы избежать мутаций
        const updatedItems = itemsCatOrder.map((item) => ({ ...item }));
      
        // Находим элемент с заданным id и сохраняем его старое значение paramorder
        const targetItem = updatedItems.find((item) => item.id === id);
        if (!targetItem) return; // Если элемента с таким id нет, возвращаем исходный массив
      
        const oldParamOrder = targetItem.paramorder;
      
        // Обновляем значение paramorder для заданного id
        targetItem.paramorder = newParamOrder;
      
        // Обновляем другие элементы, у которых paramorder совпадает с новым значением
        updatedItems.forEach((item) => {
          if (item.id !== id && item.paramorder === newParamOrder) {
            item.paramorder = oldParamOrder;
          }
        });
      
        //setItemsCatOrder(updatedItems);
        setItemsCatOrder([...updatedItems].sort((a, b) => a.paramorder - b.paramorder));
      }

      const getMinParamOrder = () => {
        if (itemsCatOrder.length === 0) return null; // Если массив пуст, возвращаем null
      
        return itemsCatOrder.reduce((min, item) => Math.min(min, item.paramorder), Infinity);
      };

      const getMaxParamOrder = () => {
        if (itemsCatOrder.length === 0) return null; // Если массив пуст, возвращаем null
      
        return itemsCatOrder.reduce((max, item) => Math.max(max, item.paramorder), -Infinity);
      };

      const upParamInCat = (id) => {
        const itemParamOrder = getParamOrderById(id);
        const paramOrder =  itemParamOrder.paramorder - 1; 
        const previousParamOrder = getPreviousParamOrder(id);

        if (previousParamOrder) {
          updateParamOrderInCat(id, paramOrder, itemParamOrder.paramorder, previousParamOrder.paramorder);
        }
        else {
          const maxParamOrder = getMaxParamOrder();
          if (typeof maxParamOrder === 'number' && !isNaN(maxParamOrder)) {
            console.log("maxParamOrder = " + maxParamOrder);
            updateParamOrderInCat(id, maxParamOrder + 1, null, null);
          }
        }
      }

      const downParamInCat = (id) => {
        const itemParamOrder = getParamOrderById(id);
        const paramOrder =  itemParamOrder.paramorder + 1; 
        const nextParamOrder = getNextParamOrder(id);

        if (nextParamOrder) {
          updateParamOrderInCat(id, paramOrder, itemParamOrder.paramorder, nextParamOrder.paramorder);
        }
        else {
          const minParamOrder = getMinParamOrder();
          if (typeof minParamOrder === 'number' && !isNaN(minParamOrder)) {
            console.log("minParamOrder = " + minParamOrder);
            updateParamOrderInCat(id, minParamOrder - 1, null, null);
          }
        }
      }

      const updateParamOrderInCat = (id, paramOrder, newParamOrder, oldParamOrder) => {
        console.log("change position " + paramOrder + " " + newParamOrder + " " + oldParamOrder);
        if (typeof newParamOrder === 'number' && !isNaN(newParamOrder) && typeof oldParamOrder === 'number' && !isNaN(oldParamOrder)) {
          console.log("selectedCatId = " + selectedCatId);
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/updateLibParamCatOrderOther`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({cat_id: selectedCatId, newparamorder: newParamOrder, oldparamorder: oldParamOrder})
            })
          .then(response => {
            response.json().then(async response => {
              console.log(response.id);
            })
          })
          .catch(error => {
                  console.error('Ошибка создания категории: ', error);
          });
        }
        
        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/updateLibParamCatOrder`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({id: id, paramorder: paramOrder})
          })
        .then(response => {
          response.json().then(async response => {
            updateParamOrderById(id, paramOrder);
          })
         })
        .catch(error => {
                console.error('Ошибка создания категории: ', error);
        });  
      }

      const addParamInCat = (id) => {

        const maxParamOrder = Math.max(...itemsCatOrder.map(item => item.paramorder));
        var paramOrder = 0;
        if (Number.isFinite(maxParamOrder)) {
          paramOrder = maxParamOrder + 1;
        }
        console.log("paramOrder = " + paramOrder);
        
        const item = getParamItemById(id);
        console.log("id = " + item.id);
        const newItem = {
          id: item.id,
          name: item.name,
          parent: item.id,
          paramcode: item.id,
          paramorder: paramOrder
        };
        console.log("selectedCatId = " + selectedCatId);
        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/insertToLibParamsCatOrder`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({typecode: item.typecode, cat_id: selectedCatId, paramcode: id, paramorder: paramOrder})
          })
        .then(response => {
          response.json().then(async response => {
            newItem.id = response.id;
            newItem.parent = response.id;
            setItemsCatOrder([...itemsCatOrder, newItem]);
            
          })
         })
        .catch(error => {
                console.error('Ошибка создания категории: ', error);
        });
      };

      const deleteParamFromCat = () => {
        console.log(itemsCatOrder);
        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/deleteLibParamCatOrder`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({id: selectedCatOrderId})
          })
        .then(response => {
          response.json().then(async response => {
            const deleteItemRecursively = (id, items) => {
              return items.filter(item => item.id !== id && item.parent !== id);
            };
            setItemsCatOrder(deleteItemRecursively(selectedCatOrderId, itemsCatOrder));
            setSelectedCatOrderId(null);
          })
         })
        .catch(error => {
                console.error('Ошибка создания категории: ', error);
        });
      };

      const handleSelectParam = (item) => {
        setSelectedParamId(item.id);
      }

      const handleSelectCat = (item) => {
        setSelectedCatId(item.id);
        setSelectedCatOrderId(null);
        setPreviousCharacteristic({ name: item.name, type: '0' });
        console.log("selectedCatId = " + item.name);
        if (typeof selectedId === 'number' && !isNaN(selectedId)) {
          /*fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/selectLibParamsCatOrder?typecode=${selectedId}&cat_id=${item.id}`)
            .then(response => response.json())
            .then(data => {
              setItemsCatOrder(data);
            })
            .catch(error => {
              console.error('Ошибка при загрузке данных:', error);
              //setLoading(false);
            });*/
            selectCategory(selectedId, item.id);
        }
      }

      const selectCategory = (typecode, cat_id) => {
        console.log("cat_id = " + typecode);
        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/selectLibParamsCatOrder?typecode=${typecode}&cat_id=${cat_id}`)
            .then(response => response.json())
            .then(data => {
              console.log(data);
              setItemsCatOrder(data);
            })
            .catch(error => {
              console.error('Ошибка при загрузке данных:', error);
              //setLoading(false);
            });
      }

      const handleSelectCatOrder = (item) => {
        setSelectedCatOrderId(item.id);
        console.log("order = " + item.id + " " + item.paramorder);
      }

      const openDeleteModal = () => {
        setIsDeleteModalOpen(true);
      };

      const handleDelete = () => {
        console.log("Элемент удалён");
        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/deleteLibParamCat`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({id: selectedCatId})
          })
        .then(response => {
          console.log("characteristic deleted");
          deleteCatItem(selectedCatId);
          setSelectedCatId(null);
          setSelectedCatOrderId(null);
          setItemsCatOrder([]);
        })
        .catch(error => {
                console.error('Ошибка удаления характеристики: ', error);
        });
      };

      const handleToggle = (id, isChecked) => {
        const updatedSelectedItems = new Set(selectedItems);
        if (isChecked) {
          updatedSelectedItems.add(id);
        } else {
          updatedSelectedItems.delete(id);
        }
        setSelectedItems(updatedSelectedItems);
      };

  return (
    <>
      {(
        <div>
      <CharacteristicModal isOpen={modalIsOpen} onClose={closeModal} onSubmit={handleCharacteristicSubmit} initialName={currentCharacteristic.name}
        initialType={currentCharacteristic.type}/>
      <ul>
        {characteristics.map((char, index) => (
          <li key={index}>{char.name} ({char.type})</li>
        ))}
      </ul>

      <FolderModal
        isOpen={folderModalIsOpen}
        onClose={closeFolderModal}
        onSubmit={handleFolderSubmit}
        initialName={currentCharacteristic.name}
        headerText={folderModalHeader}
      />
      <ul>
        {folders.map((folder, index) => (
          <li key={index}>{folder}</li>
        ))}
      </ul>
    </div>
      )}
      
        <div className="tools__wrap" onClick={handeleWrapClick}>
<div ref={modalRefHeader} className="content-container">
<div className="button-row">     
            <div
              className="tool__add__new_info add__buttons"
              onClick={() => openFolderModal(true)/*add__tool_new*/}
            >
              Добавить категорию
            </div>

            <div
  className={`tool__add__new_info add__buttons ${!selectedCatId ? 'disabled' : ''}`}
  onClick={() => {
    if (selectedCatId) {
      openFolderModal(false);
    }
  }}
  style={{ 
    cursor: !selectedCatId ? 'not-allowed' : 'pointer',
    opacity: !selectedCatId ? 0.5 : 1,
  }}
>
  Редактировать категорию
</div>
            <div
  className={`tool__add__new_info add__buttons ${!selectedCatId ? 'disabled' : ''}`}
  onClick={() => {
    if (selectedCatId) {
      openDeleteModal();  // Ваше действие на удаление
    }
  }}
  style={{ 
    cursor: !selectedCatId ? 'not-allowed' : 'pointer',
    opacity: !selectedCatId ? 0.5 : 1,
  }}
>
  Удалить категорию
</div>
<div
  className={`tool__add__new_info add__buttons`}
  onClick={handeleWrapClick}
  id='closeWrap'
>
  Закрыть
</div>
</div>

<div className="button-row">     
            <div
              className={`tool__add__new_info add__buttons ${!selectedCatId || !selectedParamId || getParamOrderByParamcode(selectedParamId) ? 'disabled' : ''}`}
              onClick={() => {
                addParamInCat(selectedParamId);
              }}
              style={{ 
                cursor: !selectedCatId && selectedParamId ? 'not-allowed' : 'pointer',
                opacity: !selectedCatId && selectedParamId ? 0.5 : 1,
              }}
            >
              Добавить характеристику в категорию
            </div>
            <div
  className={`tool__add__new_info add__buttons ${!selectedCatId || !selectedCatOrderId ? 'disabled' : ''}`}
  onClick={() => {
    setIsDeleteParamFromCatModalOpen(true);
  }}
  style={{ 
    cursor: !selectedCatId && selectedParamId ? 'not-allowed' : 'pointer',
    opacity: !selectedCatId && selectedParamId ? 0.5 : 1,
  }}
>
  Удалить характеристику из категории
</div>
</div>

<div className="button-row">     
            <div
              className="tool__add__new_info add__buttons"
              onClick={() => {
                upParamInCat(selectedCatOrderId);
              }}
              style={{ 
                cursor: !selectedCatOrderId ? 'not-allowed' : 'pointer',
                opacity: !selectedCatOrderId ? 0.5 : 1,
              }}
            >
            ↑ характеристику в категории
            </div>
            <div
  className={`tool__add__new_info add__buttons ${!selectedCatOrderId ? 'disabled' : ''}`}
  onClick={() => {
    downParamInCat(selectedCatOrderId);
  }}
  style={{ 
    cursor: !selectedCatOrderId ? 'not-allowed' : 'pointer',
    opacity: !selectedCatOrderId ? 0.5 : 1,
  }}
>
↓ характеристику в категории
</div>
</div>

            </div>

          <div ref={modalRef} className="tool__list">
          
            {
           <div className="tree-container">
            <div className="tree">
              <h4>Тип оборудования</h4>
              <Tree items={items} selectedId={selectedId} selectedParent={selectedParent} selectedItems={selectedItems} onToggle={handleToggle} onSelect={handleSelect} withCheckboxes={false} />
            </div>
            
            <div className="tree">
            <h4>Характеристики оборудования</h4>
              <Tree items={itemsTypes} selectedId={selectedParamId} selectedParent={selectedParent} selectedItems={selectedItems} onToggle={handleToggle} onSelect={handleSelectParam} withCheckboxes={false} />
            </div>

            <div className="tree">
            <h4>Категории</h4>
              <Tree items={catsItems} selectedId={selectedCatId} selectedParent={selectedParent} selectedItems={selectedItems} onToggle={handleToggle} onSelect={handleSelectCat} withCheckboxes={false} />
            </div>

            <div className="tree">
            <h4>Характеристики категории</h4>
              <Tree items={itemsCatOrder} selectedId={selectedCatOrderId} selectedParent={selectedParent} selectedItems={selectedItems} onToggle={handleToggle} onSelect={handleSelectCatOrder} withCheckboxes={false} />
            </div>
            </div>}
            
          </div>
        </div>
      
      {isDeleteModalOpen && (
        <ModalWrap><DeleteModal
          set={setIsDeleteModalOpen}
          handeleDelete={handleDelete}
          question="Вы уверены, что хотите удалить этот элемент?"
        /></ModalWrap>
      )}
      {isDeleteParamFromCatModalOpen && (
        <ModalWrap><DeleteModal
          set={setIsDeleteParamFromCatModalOpen}
          handeleDelete={deleteParamFromCat}
          question="Вы уверены, что хотите удалить этот элемент?"
        /></ModalWrap>
      )}
    </>
  );
};

export default GroupingCharacteristicsModule;